import React, { useState } from "react"
import { Link } from "react-router-dom"
import logo from "../../../images/logo/logo.png"
import horizontalLogo from "../../../images/logo/horizontal-logo.png"
// import logoLarge from '../../../images/logo/logo-large.png'
import { store } from "../../../store"
import { CUSTOMERPORTAL } from "../../../store/selectors/authSelectors"
import { COMPANY_NAME } from "../../../../config"
import { RiMenuLine } from "react-icons/ri"

export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector("#main-wrapper")
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle")
    } else {
      mainwrapper.classList.add("menu-toggle")
    }
  }, 200)
}

const NavHader = () => {
  const storeState = store.getState()
  const accessPortal = storeState.auth.accessPortal
  const [toggle, setToggle] = useState(false)

  return (
    <div className="nav-header d-flex justify-content-center">
      <div className="d-flex align-items-center ms-4">
        <div
          className="nav-contro nav-custom cursor-pointer"
          onClick={() => {
            setToggle(!toggle)
            NavMenuToggle()
          }}
        >
          <RiMenuLine color="#fff" size="30" />
        </div>

        <Link to={accessPortal === CUSTOMERPORTAL ? "/home" : "/adminportal/home"} className="brand-logo">
          <img src={horizontalLogo} width="50%" alt="jbi" />
          {/* <img className="brand-title" src={logoLarge} width={50} alt="banking" /> */}
          {/* <span className="ms-2 brand-title">{COMPANY_NAME}</span> */}
        </Link>
      </div>
    </div>
  )
}

export default NavHader
